// extracted by mini-css-extract-plugin
module.exports = {"legalBackdrop":"legal_legalBackdrop__2DxCO","legalContent":"legal_legalContent__3XU92"};